import { twMerge } from 'tailwind-merge';

import { IconProps, iconSet } from 'molecules/Icon/types';

import type { FC } from 'react';

const generateIconColorClasses = (iconColor?: string) => {
  if (!iconColor) {
    return 'fill-current stroke-current';
  }
  if (iconColor.startsWith('text-')) {
    return `${iconColor} fill-current stroke-current`;
  }

  return 'fill-current stroke-current';
};

const SPRITE_VERSION = process.env.NODE_ENV === 'development' ? Date.now() : 'v15';

const Icon: FC<IconProps> = ({ icon, size = 24, label, iconColor, color, className, ...props }) =>
  iconSet.has(icon) && (
    <svg
      width={Math.round(typeof size === 'number' ? size : 24)}
      height={Math.round(typeof size === 'number' ? size : 24)}
      aria-label={icon}
      focusable="false"
      role={label ? 'img' : undefined}
      aria-hidden={!label}
      preserveAspectRatio="xMidYMid meet"
      shapeRendering="geometricPrecision"
      className={twMerge('block', generateIconColorClasses(iconColor), className)}
      style={color ? { color } : undefined}
      {...props}
    >
      {label && <title>{label}</title>}
      <use href={`/icons/sprites.svg?${SPRITE_VERSION}#${icon}`} />
    </svg>
  );

export default Icon;
